module.exports = __webpack_public_path__ + "static/media/whyDangerous.bc90e658.mp3";